import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { useRecoilValue } from 'recoil'
import { clinicState } from '../../../globalState'
import Loader from '../../Loader/Loader'
import PersonalInfo from '../../FormCompoent/PersonalInfo/PersonalInfo'
import JotForm from '../../FormCompoent/JotForm/JotForm'
import WelcomePage from '../../FormCompoent/WelcomePage/WelcomePage'
import PatientService from '../../../services/PatientService'
import generate from '../../../utilities/generatePatientMatchingErrorModalContent'
import { formatDate } from '../../../utilities/dateFormat'
import jotFormIds from '../../../data/jot-form/form-ids-mapping'
import JotFormService from '../../../services/JotFormService'

const Phq2Gad2Screening = () => {
  const { clinic } = useRecoilValue(clinicState)
  const [loading, setLoading] = useState(false)
  const [currentPage, setCurrentPage] = useState(null)
  const [jotFormLink, setJotFormLink] = useState(null);
  const [personalDetails, setPersonalDetails] = useState(null)
  const location = useLocation();
  const formId = jotFormIds['phq2-gad2']
  const fromIdTemp = jotFormIds['phq2-gad2-temp']
  const queryParams = new URLSearchParams(location.search);
  const contact_id = queryParams.get('contactId');
  const email = queryParams.get('email')
  const phone = queryParams.get('phone')

  useEffect(() => {
    if (contact_id) {
      setCurrentPage('personal-information')
    }
    if (email || phone) {
      setCurrentPage('personal-information')
      setPersonalDetails({ email: email, phone: phone })
    }
  }, [contact_id, email, phone])

  const handlePersonalInfoSubmit = async (values) => {
    try {
      setLoading(true)
      const result = await PatientService.findOrCreatePatient({
        firstName: values.firstName,
        lastName: values.lastName,
        email: values.email || email,
        phone: values.phone || phone,
        dob: formatDate(values.dob),
        type: 'PHQ2-GAD2'
      })
      if (result?.findOrCreatePatient?.mismatch) {
        // For PHQ-2/GAD-2, we'll use the same form for mismatches since it's a simpler assessment
        const errorReason = generate(result?.findOrCreatePatient?.mismatch)

        const formLink = JotFormService.generateJotFormLink(fromIdTemp, {
          clinicName: clinic.name,
          firstName: values.firstName,
          lastName: values.lastName,
          dateOf: formatDate(values.dob),
          phone: values.phone || phone,
          email: values.email || email,
          tags: clinic.tags,
          clinicCode: clinic.clinicCode,
          clinicUuid: clinic.clinicUuid,
          screening: 'PHQ2-GAD2',
          isExisting: !!contact_id,
          contactId: result?.findOrCreatePatient?.contactId,
          clinician: values.clinician,
          isTemporary: "true",
          mismatchReason: errorReason,
          clinicSpecialty: clinic.clinicSpecialty,
          estimatedDeliveryDate: formatDate(values.estimatedDeliveryDate)
        })
        setJotFormLink(formLink)
        setCurrentPage('jot-form')
      } else if (result?.findOrCreatePatient?.contactId) {
        // This condition is for exact match
        const formLink = JotFormService.generateJotFormLink(formId, {
          clinicName: clinic.name,
          firstName: values.firstName,
          lastName: values.lastName,
          dateOf: formatDate(values.dob),
          phone: values.phone || phone,
          email: values.email || email,
          tags: clinic.tags,
          clinicCode: clinic.clinicCode,
          clinicUuid: clinic.clinicUuid,
          screening: 'PHQ2-GAD2',
          isExisting: !!contact_id,
          contactId: result?.findOrCreatePatient?.contactId,
          clinician: values.clinician,
          isTemporary: "false",
          mismatchReason: "Not Applicable",
          clinicSpecialty: clinic.clinicSpecialty,
          estimatedDeliveryDate: formatDate(values.estimatedDeliveryDate)
        })
        setJotFormLink(formLink)
        setCurrentPage('jot-form')
      }
    } catch (error) {
      console.error(error)
    }
    setLoading(false)
  };
  if (!clinic) return <Loader />;

  return !currentPage
    ? <WelcomePage setCurrentPage={setCurrentPage} />
    : currentPage === 'personal-information'
      ? <PersonalInfo handleSubmit={handlePersonalInfoSubmit} types={"PHQ2-GAD2"} personalDetails={personalDetails} loading={loading} setCurrentPage={setCurrentPage} />
      : <JotForm JotFormLink={jotFormLink} formId={formId} clinicDetails={clinic} />
};

export default Phq2Gad2Screening;
